import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { prospectFetch } from '@americanexpress/axp-acquisition-components-common';
import { formatFormDataToPSL } from '../../../DataConversion/formatFormDataToPSL';
import { useProductContext } from '../../Product';
import { useErrorContext } from '../../Common/ErrorPageProvider';
import Interstitial from '../../Common/Interstitial';
import generateArchiveData from '../../../utils/archive/generateArchiveData';

export const getPct = ({
  productShortName,
  pct,
  submitValues,
}) => {
  if (productShortName === 'platinum') {
    return pct[submitValues.plasticColor];
  }
  return pct[productShortName];
};

const Submit = ({
  next, submitValues, setMetaData, analyticsData, track,
}) => {
  const {
    host, product, inAuthId, product: {
      description,
      businessCodes: { pct, logo, sourcecode },
      productShortName,
      basicProductName,
    },
  } = useProductContext();
  const { handleError } = useErrorContext();

  useEffect(() => {
    const fetchSubmit = async () => {
      try {
        const submitTimestamp = Date.now();
        const payload = {
          pct: getPct({
            productShortName,
            pct,
            submitValues,
          }),
          logo,
          sourcecode,
          productName: description,
          submitValues,
          basicProductName,
          submitTimestamp,
        };
        const formattedArchiveData = generateArchiveData(payload);
        const metaData = await prospectFetch(`${host}/application/v2/submit`, {
          method: 'POST',
          body: JSON.stringify({
            ...formatFormDataToPSL(submitValues, product, inAuthId, formattedArchiveData),
          }),
        });
        setMetaData({ ...metaData, submitTimestamp });
        next();
      } catch (error) {
        handleError({
          logData: { message: 'submit API failed' },
        });
      }
    };
    fetchSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <Interstitial
        analyticsData={analyticsData}
        track={track}
      />
    </div>
  );
};

Submit.propTypes = {
  next: PropTypes.func.isRequired,
  submitValues: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ])).isRequired,
  setMetaData: PropTypes.func.isRequired,
  analyticsData: PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ])).isRequired,
  track: PropTypes.func.isRequired,
};

export default Submit;
